import { useProperty, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { useRef } from 'react';
import { useLinksAccessibility } from '../../custom-hooks/useLinkAccessibility';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import { useIllustration } from '../../common/utils/useIllustration';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { getModal, getPriceProps, getReadMoreLabel, getSingleChoiceProps, getUpsellProps } from '../../common/utils/productCardProps';
import { SIMPLE_VISA } from '../../products';
import SimpleVisaContent from '../common/SimpleVisaContent';
import { useSimpleVisaCardSelection, useSimpleVisaPrice } from '../common/hooks';
import SimpleVisaLogo from './SimpleVisaLogo';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = SIMPLE_VISA;
const texts = {
  additionalInformation: 'simpleVisaAbstract',
  persuasionContent: 'simpleVisaPersuasionContent',
  readMoreContent: 'simpleVisaReadMoreModalContent',
  title: 'simpleVisaTitle',
  upSell: 'simpleVisaUpSellText',
  noVisaInfo: 'Products.SimpleVisa.Travelers.Nationality.NoVisaInfo.Text',
  visaInfoHeader: 'Products.SimpleVisa.Travelers.Nationality.NoVisaInfo.Header',
  nationalityPlaceholder: 'Products.SimpleVisa.Travelers.Nationality.Placeholder',
  nationalityLabel: 'Products.SimpleVisa.Travelers.Nationality.Label'
};
const logoWrapperStyles = css`
  grid-area: 3 / 1 / 4 / 2;
`;
const MainSimpleVisa = _ref => {
  var _order$persuasion$isE, _order$persuasion;
  let {
    className,
    form,
    order,
    cardSelection,
    contactEmail,
    hasAnySelected,
    priceRaw,
    selectProduct,
    selectAllTravelers,
    updateTotalPrice,
    travelers,
    selectTraveler,
    isSelected,
    productPosition,
    layoutType
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const translation = getTranslatedTexts(texts, t);
  const {
    p
  } = useProperty();
  const rootElement = useRef(null);
  const {
    additionalInformation,
    readMoreContent,
    title,
    persuasionContent
  } = translation;
  useProductSnowplowTracking(PRODUCT_NAME, {
    rootElement,
    productPosition
  });
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: title
  });
  const illustrationUrl = useIllustration(PRODUCT_NAME);
  useSimpleVisaPrice(updateTotalPrice, priceRaw);
  const [isOpen] = useSimpleVisaCardSelection(hasAnySelected, cardSelection, selectProduct, selectAllTravelers, travelers);
  const product = getProduct(PRODUCT_ID, order, 'none');
  if (!product) {
    return null;
  }
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(translation.upSell);
  const {
    price,
    priceLabel,
    priceSuffix
  } = getPriceProps(t, isSelected, {
    ...product,
    priceRaw
  });
  const extraProps = {
    ...getSingleChoiceProps(t, p, nonDebugT),
    noVisaInfo: translation.noVisaInfo,
    visaInfoHeader: translation.visaInfoHeader,
    nationalityPlaceholder: translation.nationalityPlaceholder,
    nationalityLabel: translation.nationalityLabel,
    selectTraveler
  };
  const productCardModal = getModal((_order$persuasion$isE = (_order$persuasion = order.persuasion) === null || _order$persuasion === void 0 ? void 0 : _order$persuasion.isEnabled) !== null && _order$persuasion$isE !== void 0 ? _order$persuasion$isE : false, '', persuasionContent !== null && persuasionContent !== void 0 ? persuasionContent : '');
  const readMoreButtonLabel = getReadMoreLabel(t);
  const productData = {
    additionalInformation,
    extraProps,
    className,
    form,
    illustrationUrl,
    isHighlighted: isUpsellHighlight,
    layoutType,
    priceRaw,
    price,
    priceLabel,
    priceSuffix,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    readMoreButtonLabel,
    readMoreContent,
    shouldDisplayUpsell,
    title,
    travelers: order.travelers,
    upSell: upSellObject,
    productCardModal
  };
  return /*#__PURE__*/_jsxs(ProductLayout, {
    productData: productData,
    ref: rootElement,
    children: [/*#__PURE__*/_jsx(ProductLayout.Body, {
      children: /*#__PURE__*/_jsx("div", {
        className: logoWrapperStyles,
        children: /*#__PURE__*/_jsx(SimpleVisaLogo, {})
      })
    }), /*#__PURE__*/_jsx(SimpleVisaContent, {
      contactEmail: contactEmail,
      isOpen: isOpen,
      productName: PRODUCT_NAME,
      selectAllTravelers: () => selectAllTravelers(travelers, Boolean(cardSelection)),
      travelers: travelers
    })]
  });
};
export default MainSimpleVisa;
//# sourceMappingURL=MainSimpleVisa.js.map